module.exports = __webpack_public_path__ + "img/404.64e0a45b.png";